import React from "react"
import s from "./NewsletterBanner.module.scss"

export default function NewsletterBanner({ i18n, onJoinClick }) {
  return (
    <div className={s.banner}>
      <span className={s.text}>{i18n.text}</span>
      <button className={s.button} onClick={onJoinClick} type="button">
        {i18n.buttonLabel}
      </button>
    </div>
  )
}
